// extracted by mini-css-extract-plugin
export default {"media-dimension":"MediaUploadList_media-dimension__Urup5"};